
import { DisplayElementModel } from '@Common/PageBuilder/models/display-element.model';
import { TextStyleModel } from '@Common/PageBuilder/models/text-style.model';

import { AlertSurgeDisplayElementApiModel } from './alert-surge-display-element-api.model';
import { AlertSurgeMetricEnum } from '../enums/alert-surge-metric.enum';
import { AlertSurgeCooldownEnum } from '../enums/alert-surge-cooldown.enum';

export class AlertSurgeDisplayElementModel extends DisplayElementModel {
    declare styles: TextStyleModel;
    metric: AlertSurgeMetricEnum = AlertSurgeMetricEnum.MENTION_VOLUME;
    sensitivity: number = 200;
    coolDownPeriod: AlertSurgeCooldownEnum = AlertSurgeCooldownEnum.HOURS_24;

    // chiron values, probably not needed
    alertName?: string;
    surgePercentageChangeNegative?: number;
    surgePercentageChangePositive?: number;

    constructor(
        apiData: AlertSurgeDisplayElementApiModel
    ) {
        super();
        if (apiData) {
            this.metric = apiData.metric;
            this.sensitivity = apiData.sensitivity;
            this.coolDownPeriod = apiData.coolDownPeriod;
        }

        // HACK: needs to have a styles object or it doesn't load, didn't look into why yet
        this.styles = new TextStyleModel();
    }

    canRender(): boolean {
        return true;
    }

    onUpdate(): boolean {
        return true;
    }

    clone(): AlertSurgeDisplayElementModel {
        return new AlertSurgeDisplayElementModel(this.toApiModel());
    }

    isEqual(other: AlertSurgeDisplayElementModel): boolean {
        if (!other) {
            return false;
        }

        if (this.metric !== other.metric) {
            return false;
        }

        if (this.sensitivity !== other.sensitivity) {
            return false;
        }

        if (this.coolDownPeriod !== other.coolDownPeriod) {
            return false;
        }

        return true;
    }

    toApiModel(): AlertSurgeDisplayElementApiModel {
        return {
            metric: this.metric,
            sensitivity: this.sensitivity,
            coolDownPeriod: this.coolDownPeriod,
        } as AlertSurgeDisplayElementApiModel;
    }
}
